import React from "react";
import { ButtonWithLoader } from "@components/atoms/buttons/button-with-loader/button-with-loader";
import {
  TransferConfigurationToClientButtonObj,
  useTransferConfigurationToClientButtonHook,
} from "./use-transfer-configuration-to-client-button-hook";
import { useI18N } from "@src/language/language-context";

interface TransferConfigurationToClientButtonProps {
  useHook?: () => TransferConfigurationToClientButtonObj;
}

export const TransferConfigurationToClientButton = ({
  useHook = useTransferConfigurationToClientButtonHook,
}: TransferConfigurationToClientButtonProps) => {
  const i18n = useI18N();
  const transferConfigurationToClientButtonObj = useHook();

  const texts = {
    buttonText: i18n(
      "modules.transferConfigurationToClientButton.saveStructureButtonText",
    ),
  };

  return (
    <ButtonWithLoader
      text={texts.buttonText}
      fun={transferConfigurationToClientButtonObj.handleOnClick}
      variant={transferConfigurationToClientButtonObj.activeStyle}
      disabled={transferConfigurationToClientButtonObj.disabled}
      loading={transferConfigurationToClientButtonObj.loading}
      style={{ whiteSpace: "nowrap" }}
    />
  );
};
